import React, { useEffect, useState } from 'react';
import Typewriter from 'typewriter-effect';
import HeroScene from './Scene/HeroScene';

const roles = [
  'Backend Developer',
  'Tech Lead',
  'Freelancer',
  'Game Developer',
  'Python Lover',
];

export default function NewHero() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section
      id="hero"
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        background: '#0a0a0a',
      }}
    >
      {/* 3D Scene Background */}
      {mounted && (
        <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
          <HeroScene />
        </div>
      )}

      {/* Gradient Overlay - bottom only */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '40%',
          background: 'linear-gradient(to top, #0a0a0a, transparent)',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />

      {/* Content */}
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          maxWidth: '800px',
          padding: '0 2rem',
          textAlign: 'center',
        }}
      >
        <span className="code-tag animate-in">
          &lt;hello_founder /&gt;
        </span>

        <h1
          className="animate-in animate-in-delay-1"
          style={{
            fontSize: 'clamp(3rem, 8vw, 5.5rem)',
            fontWeight: 700,
            lineHeight: 1.05,
            marginTop: '1.5rem',
            marginBottom: '0.5rem',
            color: '#ffffff',
            letterSpacing: '-0.03em',
          }}
        >
          I'm{' '}
          <span
            style={{
              background: 'linear-gradient(135deg, #00ff88, #00cc6a)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Balaji J
          </span>
        </h1>

        <div
          className="typewriter-wrapper animate-in animate-in-delay-2"
          style={{ fontSize: 'clamp(1rem, 2.5vw, 1.4rem)', color: '#888', minHeight: '2em' }}
        >
          <Typewriter
            options={{
              strings: roles,
              autoStart: true,
              loop: true,
              deleteSpeed: 50,
              delay: 80,
            }}
          />
        </div>

        <div
          className="animate-in animate-in-delay-3"
          style={{ marginTop: '2.5rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}
        >
          <a
            href="#projects"
            className="btn-accent"
            style={{ padding: '0.85rem 2rem', fontSize: '0.9rem' }}
          >
            View My Work
          </a>
          <a
            href="#about"
            style={{
              padding: '0.85rem 2rem',
              fontSize: '0.9rem',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '8px',
              color: '#ccc',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = '#00ff88';
              e.target.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = 'rgba(255,255,255,0.15)';
              e.target.style.color = '#ccc';
            }}
          >
            About Me
          </a>
        </div>
      </div>
    </section>
  );
}